webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/alexandregeissmann/Sites/Springboard/OSS/vue-sliderX/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./example/App.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VirtualViewport__ = __webpack_require__(/*! @/VirtualViewport */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VirtualViewport: __WEBPACK_IMPORTED_MODULE_0__VirtualViewport__["a" /* default */]
  },
  data: function data() {
    return {
      orientation: 'horizontal',
      index: 0,
      loop: false,
      sliderSize: '-small'
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('keydown', function (e) {
      var key = e.key;
      if (key === 'ArrowLeft') _this.index--;
      if (key === 'ArrowRight') _this.index++;
    });
  }
});

/***/ }),
/* 3 */
/*!*********************************!*\
  !*** ./src/VirtualViewport.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_alexandregeissmann_Sites_Springboard_OSS_vue_sliderX_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualViewport_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/alexandregeissmann/Sites/Springboard/OSS/vue-sliderX/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./VirtualViewport.vue */ 4);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_alexandregeissmann_Sites_Springboard_OSS_vue_sliderX_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualViewport_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 4 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/alexandregeissmann/Sites/Springboard/OSS/vue-sliderX/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/VirtualViewport.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VirtualViewport',
  functional: true,
  props: {
    index: {
      required: true,
      type: Number
    },
    perPage: {
      required: true,
      type: Number
    },
    orientation: {
      required: true,
      type: String
    },
    offset: {
      type: Number,
      default: 1
    }
  },
  render: function render(h, ctx) {
    var props = ctx.props,
        children = ctx.children;


    var makeIntervals = function makeIntervals(perPage, offset) {
      var start = 0;
      var end = 0 + perPage;
      return [[start - offset], [start, end], [end, end + offset]];
    };

    var length = children.length;
    var index = props.index,
        perPage = props.perPage,
        loop = props.loop,
        offset = props.offset;

    var realIndex = index < 0 ? (length + index) % length : index % length;
    var intervals = makeIntervals(perPage, offset);

    var loopedChildren = realIndex !== 0 ? [].concat(_toConsumableArray(children.slice(realIndex, length)), _toConsumableArray(loop ? children.slice(0, realIndex) : [])) : children;

    var currentSlides = loopedChildren.slice.apply(loopedChildren, _toConsumableArray(intervals[1]));
    var afterSlides = loopedChildren.slice.apply(loopedChildren, _toConsumableArray(intervals[2]));

    var slides = [currentSlides, afterSlides];
    return slides;
  }
});

/***/ }),
/* 5 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/alexandregeissmann/Sites/Springboard/OSS/vue-sliderX/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Slider.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransformContainer_vue__ = __webpack_require__(/*! ./TransformContainer.vue */ 19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualViewport_vue__ = __webpack_require__(/*! ./VirtualViewport.vue */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RenderedSize_vue__ = __webpack_require__(/*! ./RenderedSize.vue */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_js__ = __webpack_require__(/*! ./helpers.js */ 23);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Slider',
  props: {
    perPage: {
      default: 3,
      type: Number
    },
    current: {
      default: 0,
      type: Number
    },
    viewportClass: {
      default: '',
      type: String
    },
    orientation: {
      default: 'vertical',
      type: String
    },
    offset: {
      default: 1,
      type: Number
    },
    loop: {
      default: true,
      type: Boolean
    },
    clone: {
      default: true,
      type: Boolean
    },
    navigationIncrement: {
      default: 1,
      type: Number
    },
    autoSize: {
      default: false,
      type: Boolean
    }
  },
  data: function data() {
    return {
      index: 0,
      isTransitioning: false,
      effectiveTransform: 0,
      elementSize: 0
    };
  },
  computed: {
    canNext: function canNext() {
      if (this.loop) return true;
      var length = this.$slots.default.length;
      return this.index + this.navigationIncrement < length;
    },
    canPrev: function canPrev() {
      if (this.loop) return true;
      return this.index - this.navigationIncrement >= 0;
    },
    transform: function transform() {
      if (this.autoSize) {
        return (this.index + this.offset) * this.elementSizeValue + 'px';
      } else {
        return (this.index + this.offset) * this.percentage + '%';
      }
    },
    padding: function padding() {
      if (this.autoSize) {
        return this.effectiveIndex * this.elementSizeValue + this.offset * this.elementSizeValue + 'px';
      } else {
        return this.effectiveIndex * this.percentage + this.offset * this.percentage + '%';
      }
    },
    effectiveIndex: function effectiveIndex() {
      if (this.autoSize) {
        return Math.floor(-this.effectiveTransform / this.elementSizeValue) - this.offset;
      } else {
        return Math.floor(this.effectiveTransform / this.percentage) - this.offset;
      }
    },
    elementSizeValue: function elementSizeValue() {
      return (this.orientation === 'horizontal' ? this.elementSize.width : this.elementSize.height) || 1;
    },
    percentage: function percentage() {
      return Math.round(1 / this.perPage * 10000) / 100;
    },
    viewportSize: function viewportSize() {
      return this.orientation === 'horizontal' ? { width: this.elementSize.width * this.perPage, height: this.elementSize.height } : { width: this.elementSize.width, height: this.elementSize.height * this.perPage };
    }
  },
  watch: {
    current: {
      immediate: true,
      handler: function handler(val) {
        this.index = val;
      }
    },
    orientation: function orientation(val) {
      this.effectiveTransform = 0;
    },
    loop: function loop(val) {
      this.index = this.current;
    }
  },
  methods: {
    next: function next() {
      this.index = this.canNext ? this.index + this.navigationIncrement : this.index;
    },
    prev: function prev() {
      this.index = this.canPrev > 0 ? this.index - this.navigationIncrement : this.index;
    }
  },
  render: function render(h) {
    var _this = this;

    var slotWithClone = function () {
      var remaining = _this.perPage + _this.offset - _this.$slots.default.length;
      var shouldClone = remaining > 0;
      if (_this.clone && shouldClone) {
        var clones = function () {
          var cloneRecursive = function cloneRecursive(remaining) {
            var clones = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            if (remaining > 0) {
              var newClones = [].concat(_toConsumableArray(clones), _toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* cloneVNodes */])(_this.$slots.default.slice(0, remaining), _this.$createElement)));
              return cloneRecursive(Math.max(0, remaining - newClones.length), newClones);
            } else {
              return clones;
            }
          };
          return cloneRecursive(remaining);
        }();
        return [].concat(_toConsumableArray(_this.$slots.default), _toConsumableArray(clones.map(function (vnode, i) {
          return Object.assign({}, vnode, { key: 'clone' + i + vnode.key });
        })));
      } else {
        return _this.$slots.default;
      }
    }();
    var children = slotWithClone.map(function (vnode) {
      var _style;

      return _this.$parent.$createElement('div', {
        class: 'elwrapper',
        key: vnode.key,
        style: (_style = {}, _defineProperty(_style, _this.orientation === 'horizontal' ? 'width' : 'height', _this.percentage + '%'), _defineProperty(_style, 'flexShrink', '0'), _style)
      }, [vnode]);
    });

    var measure = void 0;
    if (this.autoSize) {
      measure = h(__WEBPACK_IMPORTED_MODULE_2__RenderedSize_vue__["a" /* default */], {
        on: {
          changed: function changed(value) {
            _this.elementSize = value;
          }
        }
      }, [children[0]]);
    }

    var viewport = h(__WEBPACK_IMPORTED_MODULE_0__TransformContainer_vue__["a" /* default */], {
      class: ['viewport', this.viewportClass],
      on: {
        tick: function tick(value) {
          _this.effectiveTransform = value;
        }
      },
      props: {
        transformValue: this.transform,
        padding: this.padding,
        orientation: this.orientation
      }
    }, [h(__WEBPACK_IMPORTED_MODULE_1__VirtualViewport_vue__["a" /* default */], {
      props: {
        index: this.effectiveIndex,
        perPage: this.perPage,
        orientation: this.orientation
      }
    }, children)]);

    return h('div', {
      class: {
        'slider-container': true,
        '-cannext': this.canNext,
        '-canprev': this.canPrev,
        '-is-transitioning': this.isTransitioning
      },
      style: Object.assign({
        position: 'relative'
      }, this.autoSize ? {
        height: this.viewportSize.height + 'px',
        width: this.viewportSize.width + 'px'
      } : {
        // height: '100%',
        // width: '100%'
      })
    }, [this.$scopedSlots.prev && this.$scopedSlots.prev({ canPrev: this.canPrev, prev: this.prev, index: this.index }), measure, viewport, this.$scopedSlots.next && this.$scopedSlots.next({ canNext: this.canNext, next: this.next, index: this.index })]);
  }
});

/***/ }),
/* 6 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/alexandregeissmann/Sites/Springboard/OSS/vue-sliderX/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/TransformContainer.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_motion__ = __webpack_require__(/*! vue-motion */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_motion__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TransformContainer',
  props: {
    transformValue: {
      default: '0px',
      type: String
    },
    padding: {
      default: '0px',
      type: String
    },
    orientation: {
      default: 'vertical',
      type: String
    }
  },
  render: function render(h) {
    var _this = this;

    var pattern = /(\d*\.?\d*)(%|px)/;

    var _transformValue$match = this.transformValue.match(pattern),
        _transformValue$match2 = _slicedToArray(_transformValue$match, 3),
        transform = _transformValue$match2[1],
        unit = _transformValue$match2[2];

    var getCSSTransform = function getCSSTransform(value, unit) {
      return _this.orientation === 'horizontal' ? 'translate3d(-' + value + unit + ', 0px, 0px)' : 'translate3d(0px, -' + value + unit + ', 0px)';
    };
    return h(__WEBPACK_IMPORTED_MODULE_0_vue_motion__["Motion"], {
      props: {
        value: Number(transform),
        tag: 'div'
      },
      class: 'viewport',
      style: {
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden'
      },
      on: {
        // 'motion-end': this._stopTransition,
      },
      scopedSlots: {
        default: function _default(_ref) {
          var value = _ref.value;

          _this.$emit('tick', value);
          return h('div', {
            class: 'transformcontainer',
            style: _defineProperty({
              transform: getCSSTransform(value, unit),
              display: 'flex',
              flexDirection: _this.orientation === 'horizontal' ? 'row' : 'column',
              position: 'absolute',
              width: '100%',
              height: '100%'
            }, _this.orientation === 'horizontal' ? 'left' : 'top', _this.padding)
          }, _this.$slots.default);
        }
      }
    });
  }
});

/***/ }),
/* 7 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/alexandregeissmann/Sites/Springboard/OSS/vue-sliderX/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/RenderedSize.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resize_observer_polyfill__ = __webpack_require__(/*! resize-observer-polyfill */ 22);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RenderedSize',
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this._computeSize();
      var ro = new __WEBPACK_IMPORTED_MODULE_0_resize_observer_polyfill__["a" /* default */](function (entries, observer) {
        _this._computeSize();
      });
      ro.observe(_this.$el);
    });
  },

  methods: {
    _computeSize: function _computeSize() {
      var el = this.$el;
      if (!el) return;
      this.$emit('changed', {
        width: el.scrollWidth,
        height: el.scrollHeight
      });
    }
  },
  render: function render(h) {
    // clone the element received via the default slot:
    if (!this.$slots.default) return;
    var vNode = this.$slots.default[0];
    var children = vNode.children || vNode.text;
    var slot = h(vNode.tag, vNode.data, children);
    return h('span', {
      style: {
        position: 'absolute',
        visibility: 'hidden',
        left: '-10000px',
        top: '-10000px'
      }
    }, [slot]);
  }
});

/***/ }),
/* 8 */
/*!********************************!*\
  !*** multi ./example/index.js ***!
  \********************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/alexandregeissmann/Sites/Springboard/OSS/vue-sliderX/example/index.js */9);


/***/ }),
/* 9 */
/*!**************************!*\
  !*** ./example/index.js ***!
  \**************************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(/*! ./App.vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_js__ = __webpack_require__(/*! @/index.js */ 17);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/*!*************************!*\
  !*** ./example/App.vue ***!
  \*************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_alexandregeissmann_Sites_Springboard_OSS_vue_sliderX_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/alexandregeissmann/Sites/Springboard/OSS/vue-sliderX/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70093cd0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-70093cd0","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 16);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-70093cd0","scoped":false,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 15)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_alexandregeissmann_Sites_Springboard_OSS_vue_sliderX_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70093cd0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70093cd0","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./example/App.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70093cd0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/App.vue ***!
  \**************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa5 flex flex-column"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orientation),expression:"orientation"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.orientation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"horizontal"}},[_vm._v("horizontal")]),_vm._v(" "),_c('option',{attrs:{"value":"vertical"}},[_vm._v("vertical")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.loop),expression:"loop"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.loop=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":true}},[_vm._v("loop")]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v("no loop")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sliderSize),expression:"sliderSize"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sliderSize=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"-small"}},[_vm._v("small")]),_vm._v(" "),_c('option',{attrs:{"value":"-big"}},[_vm._v("big")])]),_vm._v(" "),_c('h1',[_vm._v("Default")]),_vm._v(" "),_c('div',{staticClass:"slider-container"},[_c('Slider',{staticClass:"slider flex",class:_vm.sliderSize,attrs:{"current":_vm.index,"per-page":3,"orientation":_vm.orientation,"loop":_vm.loop}},_vm._l((10),function(i){return _c('div',{key:i,staticClass:"items pa3 tc white b bg-blue"},[_vm._v("\n        "+_vm._s(i)+"\n      ")])}))],1),_vm._v(" "),_c('h1',[_vm._v("Autosize")]),_vm._v(" "),_c('Slider',{staticClass:"sliderautosized flex",class:_vm.sliderSize,attrs:{"current":_vm.index,"per-page":3,"orientation":_vm.orientation,"loop":_vm.loop,"auto-size":true}},_vm._l((10),function(i){return _c('div',{key:i,staticClass:"items pa3 tc white b bg-blue"},[_vm._v("\n      "+_vm._s(i)+"\n    ")])})),_vm._v(" "),_c('h1',[_vm._v("Clone")]),_vm._v(" "),_c('div',{staticClass:"slider-container"},[_c('Slider',{staticClass:"slider flex",class:_vm.sliderSize,attrs:{"current":_vm.index,"per-page":4,"orientation":_vm.orientation,"loop":_vm.loop,"clone":true}},_vm._l((2),function(i){return _c('div',{key:i,staticClass:"items pa3 tc white b bg-blue"},[_vm._v("\n        "+_vm._s(i)+"\n      ")])}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 17 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider_vue__ = __webpack_require__(/*! ./Slider.vue */ 18);

//
var plugin = function plugin(Vue) {

  Vue.component(__WEBPACK_IMPORTED_MODULE_0__Slider_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__Slider_vue__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (plugin);

/***/ }),
/* 18 */
/*!************************!*\
  !*** ./src/Slider.vue ***!
  \************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_alexandregeissmann_Sites_Springboard_OSS_vue_sliderX_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/alexandregeissmann/Sites/Springboard/OSS/vue-sliderX/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Slider.vue */ 5);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_alexandregeissmann_Sites_Springboard_OSS_vue_sliderX_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */
/*!************************************!*\
  !*** ./src/TransformContainer.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_alexandregeissmann_Sites_Springboard_OSS_vue_sliderX_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TransformContainer_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/alexandregeissmann/Sites/Springboard/OSS/vue-sliderX/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./TransformContainer.vue */ 6);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_alexandregeissmann_Sites_Springboard_OSS_vue_sliderX_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TransformContainer_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */,
/* 21 */
/*!******************************!*\
  !*** ./src/RenderedSize.vue ***!
  \******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_alexandregeissmann_Sites_Springboard_OSS_vue_sliderX_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RenderedSize_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/alexandregeissmann/Sites/Springboard/OSS/vue-sliderX/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./RenderedSize.vue */ 7);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_alexandregeissmann_Sites_Springboard_OSS_vue_sliderX_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RenderedSize_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */,
/* 23 */
/*!************************!*\
  !*** ./src/helpers.js ***!
  \************************/
/*! exports provided: cloneVNodes */
/*! exports used: cloneVNodes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneVNodes;

function cloneVNodes(vnodes, createElement) {
  function cloneVNode(vnode) {
    var clonedChildren = vnode.children && vnode.children.map(function (vnode) {
      return cloneVNode(vnode);
    });
    var cloned = createElement(vnode.tag, vnode.data, clonedChildren);
    cloned.text = vnode.text;
    cloned.isComment = vnode.isComment;
    cloned.componentOptions = vnode.componentOptions;
    cloned.elm = vnode.elm;
    cloned.context = vnode.context;
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    return cloned;
  }
  var clonedVNodes = vnodes.map(function (vnode) {
    return cloneVNode(vnode);
  });
  return clonedVNodes;
}

/***/ })
],[8]);


// WEBPACK FOOTER //
// client.5a6a1d2e.js